import React, { FC } from 'react';
import { Button, ButtonProps } from '@mui/material';

import { Dropdown, DropdownProps } from './Dropdown';


export type ButtonDropdownProps = Omit<DropdownProps, 'children'> & {
  label: React.ReactElement | string;
  dropDownStyle?: React.CSSProperties;
  buttonProps?: ButtonProps & {
    endIcon?: (open: boolean) => React.ReactElement;
  };
}

export const ButtonDropdown: FC<ButtonDropdownProps> = ({ label, content, placement, buttonProps, dropDownStyle = {} }) => (
  <Dropdown
    content={content}
    placement={placement}
    style={dropDownStyle}
  >
    {({ ref, handleToggleDropdownMenu, openDropdownMenu }) => (
      <Button
        {...buttonProps}
        ref={ref}
        aria-label="options menu"
        aria-haspopup="menu"
        onClick={handleToggleDropdownMenu}
        endIcon={buttonProps?.endIcon && buttonProps.endIcon(openDropdownMenu)}
      >
        {label}
      </Button>
    )}
  </Dropdown>
);
